import React, {useContext, useEffect, useState} from 'react';
import {DataContext} from '../../../../../utils/DataProvider';
import {MilkQualityServices} from '../services/MilkQualityServices';
import {createOrUpdateDataFull, getRowValue} from '../../../../../utils/utils';
import {DatagridActionsHelper} from '../../../utils/datagridActionsHelper';
import DataGrid from '../../../../../components/DataGrid';
import {MilkQualityHelper} from '../utils/MilkQualityHelper';

import '../css/milk-quality.scss';
import {ServicesHelper} from '../../services/ServicesHelper';

const MilkQuality = () => {
  const {state, stateFetchParams, stateMessage, filterParams} = useContext(DataContext);
  const [data, setData] = useState(null);
  const [total, setTotal] = useState(0);
  const [reset, setReset] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await MilkQualityServices.list(
          {
            'wherecustom[date$partialdate:and]': `${state.harvest.first_year}-07;>=,${state.harvest.last_year}-06;<=`,
            // ...stateFetchParams,
            ...stateFetchParams,
            perPage: 60,
            ...filterParams,
          },
          {
            first_year: state.harvest.first_year,
            last_year: state.harvest.last_year,
          },
        );
        const {data: currentData, categories: cats} = response;

        setCategories(cats);
        setData(currentData.resultList);
        setTotal(currentData.size);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reset, JSON.stringify(state).toLowerCase()]);// eslint-disable-line

  const handleChange = async (inputs) => {
    inputs.currentUser = state.user.id;
    try {
      return await createOrUpdateDataFull(inputs, state, MilkQualityServices.post, MilkQualityServices.put);
    } catch (error) {
      return error;
    } finally {
      setReset(!reset);
    }
  };

  const validateHeaderCallback = async (dataGridRows, field, checked, valueKey) => {
    const promisses = [];
    dataGridRows.forEach(async (line) => {
      if (getRowValue(line, field, valueKey, true, null, field) >= 0) {
        const sanitizeLine = MilkQualityServices.prepareToSave({
          ...{...state, ...line, currentUser: state.user.id, validated: checked},
          [valueKey]:
            Number(getRowValue(line, field, valueKey, true, null, field)) >= 0 ? parseFloat(getRowValue(line, field, valueKey, true, null, field)) : null,
        });
        const tempReq = ServicesHelper.post(MilkQualityServices.endpoint.concat('/batch'), [...sanitizeLine]);
        promisses.push(tempReq);
      }
    });
    const response = await Promise.all(promisses);
    setReset(!reset);
    return response;
  };
  const actions = DatagridActionsHelper.actions(
    {
      handleDelete: async (value, cel, key) => {
        try {
          const sanitizeLine = MilkQualityServices.prepareToSave({
            ...{...state, ...value, currentUser: state.user.id, [key]: -1},
          });
          const response = ServicesHelper.post(MilkQualityServices.endpoint.concat('/batch'), [...sanitizeLine]);
          setReset(!reset);
          return response;
        } catch (error) {
          return error;
        }
      },
    },
    {add: true},
  );

  return (
    <>
      {stateMessage}
      {data && (
        <div className="livesotckStock fixedHeader milk-quality">
          <DataGrid
            onChange={handleChange}
            header={[
              MilkQualityHelper.columns(state.harvest.first_year, [7, 8, 9, 10, 11, 12], 'quantity'),
              MilkQualityHelper.columns(state.harvest.last_year, [1, 2, 3, 4, 5, 6], 'quantity'),
            ]}
            fixedColumn={
              {
                header: [
                  {
                    key: 'id',
                    valueKey: 'label',
                    width: '390px',
                    height: 'auto',
                    field: 'label',
                    name: 'Categoria',
                    textAlign: 'Center',
                    editType: 'defaultedit',
                    disabledEdit: true,
                    disableFilter: true,
                  },
                ],
                data: categories.map((cat) => ({...cat, id: cat.value})),
              } || null
            }
            validateCallback={validateHeaderCallback}
            data={data}
            keyProp="key"
            keyValueProp="valueKey"
            titleProp="name"
            editable=""
            actions={actions}
            totalItems={total}
            disabledPaginate
            maxHeight="100%"
          />
        </div>
      )}
    </>
  );
};

export default MilkQuality;
